import { initialState } from '../../initState'
import type { State } from '../../typings'

export function initializeProducer(): State {
  return { ...initialState }
}
